import { t } from "ttag";

import { env } from "@/config/env";
import { ReferralDashboardModal } from "@/features/billing/sections";
import { useBoolean } from "@/shared/hooks";
import { GiftIcon, Header } from "@/shared/ui";

const referralEnabled = env.VITE_REFERRAL_ENABLED;

export const BillingHeader = () => {
  const {
    value: showReferralDashboardModal,
    setTrue: openReferralDashboardModal,
    setFalse: closeReferralDashboardModal,
  } = useBoolean(false);

  return (
    <>
      <Header.Root>
        <Header.Content className="flex-row items-center justify-between">
          <Header.Title>{t`Billing`}</Header.Title>

          {referralEnabled && (
            <Header.Actions className="self-center">
              <Header.Button onClick={openReferralDashboardModal}>
                <GiftIcon className="size-4" />
                <span>{t`Referral program`}</span>
              </Header.Button>
            </Header.Actions>
          )}
        </Header.Content>
      </Header.Root>

      {referralEnabled && (
        <ReferralDashboardModal
          show={showReferralDashboardModal}
          onClose={closeReferralDashboardModal}
        />
      )}
    </>
  );
};
